import {
    InputCommon,
    StyledButton,
    StyledForm,
    StyledForgotLink,
    ClipLoaderCommon,
} from "@components";
import { ILogin } from "@interfaces";
import { IHandleChange, IHandleBlur, IHandleSubmit } from "@interfaces";
import { Divider } from "@mui/material";
import GoogleLoginButton from "../GoogleLoginButton";
import CustomAppleSignIn from "../AppleLoginButton";
import { theme } from "@utilities";

interface LoginFormProps {
    values: ILogin;
    handleChange: IHandleChange;
    handleBlur: IHandleBlur;
    handleSubmit: IHandleSubmit;
    isSubmitting: boolean;
    errors: { [key: string]: string };
    touched: { [key: string]: boolean };
    isAppleCallback?: boolean;
}

export const LoginFormComponent = (props: LoginFormProps) => {
    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        touched,
        errors,
        isAppleCallback,
    } = props;

    const forgotPasswordLink = "/forgot-password";

    return (
        <StyledForm onSubmit={handleSubmit}>
            <InputCommon
                name="email"
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.email}
                label="Email"
                type="text"
                error={touched.email && errors.email ? errors.email : ""}
            />
            <InputCommon
                name="password"
                handleChange={handleChange}
                handleBlur={handleBlur}
                value={values.password}
                label="Password"
                type="password"
                error={touched.password && errors.password ? errors.password : ""}
            />
            <StyledForgotLink>
                <a href={forgotPasswordLink}>Forgot password?</a>
            </StyledForgotLink>
            <StyledButton
                $borderRadius={theme.borderRadius.small}
                color={theme.gradients.button}
                disabled={isSubmitting}
                type="submit"
            >
                {isSubmitting ? (
                    <ClipLoaderCommon size={24} color={theme.colors.highlight} margin={0} />
                ) : (
                    "Log In"
                )}
            </StyledButton>
            <Divider
                style={{
                    color: theme.colors.gray_4,
                    marginTop: "22px",
                    marginBottom: "2px",
                    fontWeight: "bold",
                    fontSize: "12px",
                }}
            >
                OR
            </Divider>
            <CustomAppleSignIn isLoading={isAppleCallback} />
            <GoogleLoginButton />
        </StyledForm>
    );
};

// Wrapper for social login buttons
